
import React, { useState } from 'react';
import ProductDisplay from '../../components/ProductDisplay.js';
// import Carousel from '../components/Carousel';
import Carousel from '../../components/Carousel.js'
import CarouselComponent from '../../components/CarouselComponent.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import tech1 from "../../assests/technology (1).png";
import tech2 from "../../assests/technology (2).png";
import tech3 from "../../assests/plasmOX.png";

// import aop1 from 'product/aop.png'
// import FAQSection from '../components/FAQSection';
function ChargeMax() {
    const [openFAQ, setOpenFAQ] = useState(null);

    const faqs = [
        {
            id: 1,
            question: "Features",
            answer: {
                type: "iconText",
                iconContent: [
                    {
                        image: "../product/esp/Group 146.png",
                        additionalText: "Advanced needle-point ionization technology."
                    },
                    {
                        image: "../product/esp/Group 147.png",
                        additionalText: "No fragile tungsten ionizing wire"
                    },
                    {
                        image: "../product/esp/Group 149.png",
                        additionalText: "Uniform and stable corona discharge generation."
                    },
                    {
                        image: "../product/esp/Group 150.png",
                        additionalText: "Robust stainless-steel needle electrode construction."
                    },
                    {
                        image: "../product/esp/Group 148.png",
                        additionalText: "Reduced maintenance compared to wire-based ESP systems."
                    },
                    {
                        image: "../product/esp/Group 146.png",
                        additionalText: "Washable and reusable collector cells."
                    },
                    {
                        image: "../product/esp/Group 147.png",
                        additionalText: "Long service life and reduced lifecycle costs."
                    }
                ]
            }
        },
        {
            id: 2,
            question: "Benefits",
            answer: {
                type: "list",
                items: [
                    "High-efficiency removal of PM2.5, PM10, smoke, and airborne particulates.",
                    "Higher reliability than conventional wire-type electrostatic filters.",
                    "Reduced downtime and maintenance costs.",
                    "Lower energy consumption due to minimal airflow resistance.",
                    "Low pressure drop for energy-efficient operation.",
                    "Reduced replacement costs associated with damaged ionizing wires."
                ]
            }
        },
        {
            id: 3,
            question: "Protection From",
            answer: {
                type: "images",
                images: [ "../product/aop/Group 131.png","../product/aop/Group 130.png"],
                imagescontent: ["Particulate Matter","Pollens, pet Dander,etc"]

            }
        },
        {
            id: 4,
            question: "Application Area",
            answer: {
                type: "words",
                words: [
                    "Government", "Airport", "Offices", "Residential", "University",
                    "Hospitality", "Transportation", "Factories", "Railways",
                ]
            }
        }
    ];



    const product = {
        headingText: "HVAC Duct Air Purification",
        title: "chargeMAX™ Polar Filter",
        downloadFile: "https://ultrapureindia.in/pdf/ESP%20Brochure.pdf",
        mainImage: 'new_assets/Chargemax.png',
        relativeImages: [
            "Product/ESP.png",
            "Product/ESP.png",
            "Product/ESP.png",
            "Product/ESP.png",
        ],
    };
    const toggleFAQ = (id) => {
        setOpenFAQ(openFAQ === id ? null : id);
    };

    return (
        <div className="overflow-x-hidden">
            <ProductDisplay
                headingText={product.headingText}
                title={product.title}
                downloadFile={product.downloadFile}
                mainImage={product.mainImage}
                relativeImages={product.relativeImages}
            />


            <div className="flex flex-col md:flex-row  p-4 md:p-8 rounded-lg">
                <div className="w-full md:w-1/2 mt-4 md:mt-0 md:ml-6 flex flex-col justify-center">
                    <p className="text-gray-700 p-8 text-justify">
                        ChargeMax Poler filter is an advanced air filtration system designed to remove fine particulate matter, smoke, aerosols, and airborne contaminants from HVAC air streams with exceptional efficiency and reliability. Unlike conventional electrostatic precipitators that utilize fragile tungsten ionizing wires, this innovative system employs precision-engineered needle-point ionization electrodes to generate a stable and uniform electrostatic field.</p>
                </div>
                <div className="w-full md:w-1/2 flex justify-evenly items-center">
                    <div className="w-1/2">
                        {/* <img src={tech1} alt="plasma" className=" h-auto rounded-lg" /> */}
                        <img src={tech3} alt="plasma" className=" h-auto rounded-lg" />

                        {/* <h6 className="font-bold text-sm">nanoX® Technology</h6> */}
                    </div>

                    {/* <div className="w-1/2"> */}
                    {/* <h6 className="font-bold w-full text-sm">plasmOX® Technology</h6> */}
                    {/* </div> */}
                </div>
            </div>
            {/* faq */}
            <div className="mx-auto bg-white p-8 rounded-lg shadow-lg">
                {/* <h2 className="text-2xl font-bold mb-6">Frequently Asked Questions</h2> */}
                {faqs.map((faq) => (
                    <div key={faq.id} className="mb-4">
                        <button
                            className={`w-full text-left p-4 rounded-full flex justify-between items-center focus:outline-none transition-colors duration-300 ${openFAQ === faq.id
                                ? "bg-gradient-to-r from-textBlue to-ultragreen text-white"
                                : "bg-gray-200 text-black"
                                }`}
                            onClick={() => toggleFAQ(faq.id)}
                        >
                            <span className="text-lg">{faq.question}</span>
                            <FontAwesomeIcon
                                icon={openFAQ === faq.id ? faChevronDown : faChevronRight}
                            />
                        </button>
                        {openFAQ === faq.id && (
                            <div className="p-4 bg-gray-100 rounded-lg">
                                {faq.answer.type === "iconText" && (
                                    <div className="space-y-4 flex flex-wrap">
                                        {faq.answer.iconContent.map((content, index) => (
                                            <div key={index} className="flex sm:flex-wrap items-center w-full lg:w-1/4  p-3">
                                                {/* <img src={content.icon} alt="Icon" className="h-6 w-6 mr-2" />
                                                <span>{content.text}</span> */}
                                                <div className="flex items-center">
                                                    <img src={content.image} alt="features" className="h-15 w-15 mx-2" />
                                                    <span>{content.additionalText}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {faq.answer.type === "list" && (
                                    <ul className="list-disc list-inside">
                                        {faq.answer.items.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                                {faq.answer.type === "images" && (
                                    <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                                        {faq.answer.images.map((image, index) => (
                                            <div key={index} className="text-center">
                                                <img src={image} alt={`Image ${index + 1}`} className="mx-auto" />
                                                <span className="block mt-2">{faq.answer.imagescontent[index]}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {faq.answer.type === "words" && (
                                    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 ml-5 ">
                                        {faq.answer.words.map((word, index) => (
                                            <li key={index}>{word}</li>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* product carousel */}
            {/* <Carousel /> */}
            {/* client tested carousel	 */}
            <CarouselComponent />
        </div>
    );
}

export default ChargeMax;
